import { Cart, CartEntity } from "./cartInterfaces";

import { isDefined } from "Utils/functions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useCartSelector } from "./cartSelectors";
import { fetchCartStart } from "./cartSlice";

export const useCart = (
  cartId: string,
  forceRecalculate = false,
): CartEntity => {
  const dispatch = useDispatch();
  const cart = useCartSelector();

  useEffect(() => {
    const cartExist = isDefined(cart.current);
    const isNewCart = isDefined(cartId) && cartId !== cart.current?.cartId;
    if (forceRecalculate === true || !cartExist || isNewCart) {
      dispatch(fetchCartStart({ cartId, forceRecalculate }));
    }
  }, [cartId, forceRecalculate]);

  return cart;
};

export const useOptionalCart = (
  cartId: string | undefined | null,
): CartEntity => {
  const dispatch = useDispatch();
  const cart = useCartSelector();

  useEffect(() => {
    if (isDefined(cartId) && !isDefined(cart.current) && !cart.isLoading) {
      dispatch(fetchCartStart({ cartId }));
    }
  }, [cartId]);

  return cart;
};

export const useCurrentCart = (): Cart | null => useCartSelector().current;

export const useIsAdvisorCart = (): boolean =>
  !!useCartSelector().current?.cartOwnedByAdvisor;

/**
 * Safely use cartId from URL.
 * * Handles cases where Cart IDs are all lowercase.
 */
export const useCartIdParam = (): string => {
  const { cartId } = useParams<{ cartId: string }>();
  return cartId.startsWith("c") ? `C${cartId.slice(1)}` : cartId;
};
